<template>
  <div class="subitem-info">
    <span class="name">{{ name }}</span>
    <canvas ref="canvas"></canvas>
    <span class="size">{{ size | fixedTwo }}</span>
  </div>
</template>

<script>
import QRCode from 'qrcode'
export default {
  props: {
    name: String,
    size: Number,
    path: String
  },
  methods: {
    initQRCode () {
      let canvas = this.$refs.canvas
      QRCode.toCanvas(canvas, this.path, {
        width: 92,
        height: 92,
        margin: 0
      })
    }
  },
  filters: {
    fixedTwo (value) {
      return value ? `${value.toFixed(2)} M` : ''
    }
  },
  mounted () {
    this.initQRCode()
  }
}
</script>

<style scoped lang="less" rel="stylesheet/less">
.subitem-info {
  display: inline-block;
  width: 92px;
  text-align: center;
  margin-right: 72px;
  &:last-child {
    margin-right: 0;
  }
  .name {
    font-size: 12px;
    color: #b5b5b5;
    line-height: 12px;
    margin-bottom: 10px;
    display: block;
  }
  .size {
    font-size: 12px;
    color: #b5b5b5;
    line-height: 12px;
    margin-top: 8px;
    display: block;
    height: 12px;
  }
}
</style>
